var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAltitudeSensor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2583_12114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7917 43.3958H3.70834V41.5417H40.7917V43.3958ZM29.6667 19.2564V16.6346L28.7396 15.7057L23.216 21.2589L12.0521 10.0208L3.67682 18.4443V21.1143L12.0521 12.7094L21.8922 22.5921L16.2592 28.2566L17.5868 29.5841L28.7396 18.3275L29.6667 19.2564ZM35.2292 22.2101V24.8338L40.7917 30.4111V27.7856L35.2292 22.2101ZM38.9375 2.60416H25.9583V4.45833H38.9375V2.60416ZM33.375 36.5224V9.47756L38.2811 14.3837L39.592 13.0728L32.4479 5.92868L25.302 13.0728L26.6129 14.3837L31.5208 9.47756V36.5224L26.6147 31.6163L25.3038 32.9272L32.4479 40.0713L39.5939 32.9254L38.283 31.6145L33.375 36.5224Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2583_12114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5,
    height: 44.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltitudeSensor);
export default __webpack_public_path__ + "static/media/altitude-sensor.32f59a3892729e5075c0611576ba26f5.svg";
export { ForwardRef as ReactComponent };